const internalIdentity = value => /(?:^lid:|@(?:lid|s\.whatsapp\.net|c\.us)$)/i.test(String(value || "")) || /^\d{16,}$/.test(String(value || ""));
export const contactNumber = contact => {
  const value = String(contact?.number || "").trim();
  const lid = String(contact?.lid || "").replace(/^lid:/i, "").replace(/@lid$/i, "");
  return value && !contact?.isGroup && value !== lid && !internalIdentity(value) ? value : "";
};
export const contactDisplayName = contact => {
  const name = String(contact?.name || "").trim();
  return name && !internalIdentity(name) ? name : contactNumber(contact) || (contact?.isGroup ? "Grupo WhatsApp" : "Contato WhatsApp");
};
export const contactLabel = contact => {
  const name = contactDisplayName(contact);
  const number = contactNumber(contact);
  return number && name !== number ? name + " · " + number : name;
};
export const contactSearchTerm = value => {
  const query = String(value || "").trim();
  return /^[+\d\s().-]+$/.test(query) ? query.replace(/\D/g, "") : query.toLocaleLowerCase();
};
export const contactMatchesSearch = (contact, search) => {
  const query = contactSearchTerm(search);
  return !query || String(contact?.name || "").toLocaleLowerCase().includes(query) || String(contact?.number || "").includes(query);
};
export const mergeContact = (previous, incoming) => {
  if (!incoming) return previous;
  if (!previous || String(previous.id) !== String(incoming.id)) return incoming;
  const oldTime = Date.parse(previous.updatedAt);
  const newTime = Date.parse(incoming.updatedAt);
  if (Number.isFinite(oldTime) && Number.isFinite(newTime) && newTime < oldTime) return previous;
  return { ...previous, ...incoming };
};
export const updateTicketContacts = (tickets, incoming) => tickets.map(ticket =>
  String(ticket.contactId ?? ticket.contact?.id) === String(incoming?.id)
    ? { ...ticket, contact: mergeContact(ticket.contact, incoming) }
    : ticket
);

export const contactsReducer = (state, action) => {
  if (action.type === "RESET") return [];
  if (action.type === "DELETE_CONTACT") return state.filter(contact => String(contact.id) !== String(action.payload));
  if (action.type === "LOAD_CONTACTS") {
    const next = [...state];
    action.payload.forEach(contact => {
      const index = next.findIndex(item => String(item.id) === String(contact.id));
      if (index === -1) next.push(contact);
      else next[index] = mergeContact(next[index], contact);
    });
    return next;
  }
  if (action.type === "UPDATE_CONTACTS") {
    const incoming = action.payload;
    if (!incoming?.id) return state;
    const existing = state.find(contact => String(contact.id) === String(incoming.id));
    const contact = mergeContact(existing, incoming);
    if (!contactMatchesSearch(contact, action.search)) return state.filter(item => String(item.id) !== String(contact.id));
    return existing ? state.map(item => String(item.id) === String(contact.id) ? contact : item) : [contact, ...state];
  }
  return state;
};
